const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M286.776 37.828H27.093c-5.646 0-10.224 4.578-10.224 10.224s4.578 10.224 10.224 10.224h249.46v180.449H58.787c-21.14 0-38.339-17.199-38.339-38.339 0-16.816 10.887-31.127 25.978-36.283l-7.342 10.485c-3.239 4.626-2.115 11.001 2.51 14.239a10.176 10.176 0 0 0 5.856 1.85c3.223 0 6.395-1.521 8.384-4.36l21.477-30.671a10.217 10.217 0 0 0 1.693-7.64 10.222 10.222 0 0 0-4.204-6.6L44.128 119.93c-4.625-3.238-11-2.115-14.238 2.511-3.239 4.625-2.115 11 2.511 14.238l10.262 7.186C18.065 150.894 0 173.562 0 200.386c0 32.415 26.371 58.787 58.787 58.787h227.99c5.646 0 10.224-4.578 10.224-10.224V48.052c-.001-5.646-4.579-10.224-10.225-10.224Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.0808 0 0 .0808 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 151c24.813 0 45 20.187 45 45 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-41.355-33.645-75-75-75s-75 33.645-75 75v45h-15c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15h15c-.267 1.404 3.046 35.742-25.606 64.393C145.976 344.81 152.646 361 166 361h150c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15H196.061c16.632-29.578 14.798-58.837 14.939-60h45c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15h-45v-45c0-24.813 20.187-45 45-45Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.0442 0 0 .0442 3.632 1.346)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.99e4b50bbc607f419edb4f72c68cf530.svg";
export { ForwardRef as ReactComponent };